import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import Stakeholder from '@/stakeholders/entities/stakeholder'
import stakeholdersService from '@/stakeholders/services/stakeholders-service'
import StakeholderDialog from '@/stakeholders/components/stakeholder-dialog/stakeholder-dialog'
import StakeholdersRequest from '../requests/stakeholders-request'
import pagingWatcher from '@/common/pagination/utils/paging-watcher'

@Component
export default class Stakeholders extends Vue {
  @Ref()
  private dialog!: StakeholderDialog

  private loading: boolean = false
  private stakeholders: Stakeholder[] = []

  private request = new StakeholdersRequest()

  @Watch('request.paging', { deep: true })
  private paginationChanged = pagingWatcher(this.fetchAll)

  private async fetchAll() {
    this.loading = true
    const response = await stakeholdersService.findAllAsync(this.request)
    this.stakeholders = response.items
    this.request.paging.totalItems = response.totalItems
    this.loading = false
  }

  private create() {
    this.dialog.openNew(new Stakeholder())
  }

  private edit(stakeholder: Stakeholder) {
    this.dialog.openEdit(stakeholder)
  }

  private async deleteStakeholder(stakeholder: Stakeholder) {
    await stakeholdersService.deleteAsync(stakeholder)
    await this.fetchAll()
  }

  private async createConfirm(stakeholder: Stakeholder) {
    if (await stakeholdersService.createAsync(stakeholder)) {
      await this.fetchAll()
      this.dialog.close()
    }
  }

  private async editConfirm(stakeholder: Stakeholder) {
    if (await stakeholdersService.updateAsync(stakeholder)) {
      await this.fetchAll()
      this.dialog.close()
    }
  }

  private async created() {
    this.request.paging.sortBy = ['name']
    this.request.paging.sortDesc = [false]

    await this.fetchAll()
  }
}
